module.exports = __webpack_public_path__ + "img/BS38.049e4a3d.svg";